// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill"
import Vue from 'vue'
import App from './App'
import StatisticsForm from './components/StatisticsForm'
import AdvancedStatisticsForm from './components/AdvancedStatisticsForm'
import KosovoStatisticsForm from './components/KosovoStatisticsForm'
import KosovoAdvancedStatisticsForm from './components/KosovoAdvancedStatisticsForm'
import Styles from './style.scss'
import timeConfig from './infrastructure/timeConfig'

Vue.config.productionTip = false;
window.eventBus = new Vue();

Vue.use(timeConfig)


// fix for Internet explorer - it hasn't got startsWith method
// startsWith comes with ES6
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        components: { App },
        template: '<App/>'
    });
}

if (document.getElementById('statistics-form')) {
    new Vue({
        el: '#statistics-form',
        components: { StatisticsForm },
        template: '<StatisticsForm/>'
    });
}


if (document.getElementById('advanced-statistics-form')) {
    new Vue({
        el: '#advanced-statistics-form',
        components: { AdvancedStatisticsForm },
        template: '<AdvancedStatisticsForm/>'
    });
}


if (document.getElementById('kosovo-statistics-form')) {
    new Vue({
        el: '#kosovo-statistics-form',
        components: { KosovoStatisticsForm },
        template: '<KosovoStatisticsForm/>'
    });
}


if (document.getElementById('kosovo-advanced-statistics-form')) {
    new Vue({
        el: '#kosovo-advanced-statistics-form',
        components: { KosovoAdvancedStatisticsForm },
        template: '<KosovoAdvancedStatisticsForm/>'
    });
}


if (document.getElementById('header')) {
    new Vue({
        el: '#header',
        data() {
            return {
                isOpen: false
            }
        },
        methods: {
            toggleBodyClass(action, className) {
                // const el = document.body;
                const el = document.querySelector('#page-wrapper');

                if (action === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },
            toggleNav() {
                this.isOpen = !this.isOpen;

                if (this.isOpen) {
                    this.toggleBodyClass('addClass', 'no-scroll');
                } else {
                    this.toggleBodyClass('removeClass', 'no-scroll');
                }
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/main.js